/**
 * vue-filter
 * suliyu
 * 2017年10月20日15:00:24
 */

import Vue from 'vue'
import vueFilter from 'vue-filter'
Vue.use(vueFilter)

export default {
  name: 'vueFilter'
}
